module.exports = __webpack_public_path__ + "static/media/browser-coconote-1.636d5105.png";